import { render, staticRenderFns } from "./Tooltip.vue?vue&type=template&id=312f7bfe&scoped=true&"
var script = {}
import style0 from "./Tooltip.vue?vue&type=style&index=0&id=312f7bfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312f7bfe",
  null
  
)

export default component.exports